import { createContext, useContext } from 'react';

import { DEFAULT_THEME_MODE, type ThemeMode } from './ThemeMode';

export type ThemeModeState = {
  mode: ThemeMode;
  toggle: () => void;
};

export const ThemeModeContext = createContext<ThemeModeState>({
  mode: DEFAULT_THEME_MODE,
  toggle: () => undefined,
});

export const useThemeMode = (): ThemeModeState => useContext(ThemeModeContext);
